import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Console from "./components/Console";
import Dashboard from "./components/Dashboard";
import Table from "./components/Table";

function Review() {
  let { isAuth } = useSelector((state) => state.auth);

  let [search, setSearch] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth === false) navigate("/login");
  }, [isAuth]);

  return (
    <div className="flex flex-col gap-8">
      <Dashboard></Dashboard>
      <Console setSearch={setSearch}></Console>
      <Table></Table>
    </div>
  );
}

export default Review;
